import RevxFlexLayout from 'components/RevxFlexLayout';
import { ConfigSvcProps } from '..';
import CommonJobSvcBorder from '../common/CommonJobSvcBorder';
import CommonJobSvcCotainer from '../common/CommonJobSvcCotainer';
import CommonJobSvcInstructions from '../common/CommonJobSvcInstructions';
import CommonJobSvcMessage from '../common/CommonJobSvcMessage';
import CommonJobSvcName from '../common/CommonJobSvcName';
import CommonJobSvcOption from '../common/CommonJobSvcOption';
import CommonJobSvcSpec from '../common/CommonJobSvcSpec';
import CommonQuantityPerBundle from '../common/CommonQuantityPerBundle';
import { useHideSvc } from '../hook/useHideSvc';
import { useHideSvcContainer } from '../hook/useHideSvcContainer';

const Prepress = (props: ConfigSvcProps) => {
  const hideSvc = useHideSvc(props);
  const hideSvcContainer = useHideSvcContainer(props);
  // const perforateRadioProps: RevxRadioProps = {
  //   outSideRevxLayoutProps: {
  //     align: 'top',
  //     justify: 'left',
  //     wrap: 'wrap',
  //     direction: 'column',
  //     className: 'jobconfig-jobOption-content-outSideOption-default',
  //     style: {
  //       paddingBottom: 0,
  //     },
  //   },
  //   inSideRevxLayoutProps: {
  //     align: 'top',
  //     justify: 'left',
  //     className: 'jobconfig-jobOption-content-inSideOption-default',
  //     style: {
  //       height: 42,
  //       paddingTop: 10,
  //     },
  //   },
  //   options:  [
  //     {
  //       value: 'File Prep ($60/hr - $30 minimum)',
  //       children: <span>File Prep ($60/hr - $30 minimum)</span>,
  //     },
  //     {
  //       value: 'Photo Retouch ($60/hr - $30 minimum)',
  //       children: <span>Photo Retouch ($60/hr - $30 minimum)</span>,
  //     },
  //     {
  //       value: 'Graphic Design ($125/hr - $60 minimum)',
  //       children: <span>Graphic Design ($125/hr - $60 minimum)</span>,
  //     },
  //     {
  //       value: 'Scanning ($0.49 per page up to 11’’x17’’ - $5 minimum)',
  //       children: (
  //         <span>Scanning ($0.49 per page up to 11’’x17’’ - $5 minimum)</span>
  //       ),
  //     },
  //   ],
  // };

  return (
    <>
      <div style={hideSvc}>
        <RevxFlexLayout align="top" justify="justify-start">
          <CommonJobSvcName {...props} />
          <div>
            {/* <RevxFlexLayout style={{ marginTop: 21 }}>
            <div style={{ paddingLeft: 28 }}>
              <div
                className="jobconfig-jobOption-content-label"
                style={{ marginBottom: 14 }}
              >
                originals
              </div>
              <RevxFlexLayout direction="column">
                <RevxFlexLayout style={{ height: 42 }}>
                  <Input className="jobconfig-jobOption-perforate-input" />
                </RevxFlexLayout>
                <RevxFlexLayout style={{ height: 42 }}>
                  <Input className="jobconfig-jobOption-perforate-input" />
                </RevxFlexLayout>
                <RevxFlexLayout style={{ height: 42 }}>
                  <Input className="jobconfig-jobOption-perforate-input" />
                </RevxFlexLayout>
                <RevxFlexLayout style={{ height: 42 }}>
                  <Input className="jobconfig-jobOption-perforate-input" />
                </RevxFlexLayout>
              </RevxFlexLayout>
            </div>
          </RevxFlexLayout> */}
            <CommonJobSvcCotainer {...props}>
              <CommonJobSvcSpec {...props} disabled={hideSvcContainer} />
              <CommonJobSvcOption {...props} disabled={hideSvcContainer} />
              <CommonQuantityPerBundle {...props} disabled={hideSvcContainer} />
              <CommonJobSvcInstructions
                {...props}
                disabled={hideSvcContainer}
              />
              <CommonJobSvcMessage {...props} disabled={hideSvcContainer} />
            </CommonJobSvcCotainer>
          </div>
        </RevxFlexLayout>
        <CommonJobSvcBorder />
      </div>
    </>
  );
};

export default Prepress;
